import React from "react";
import { View } from "react-native";
import type { StyleProp, ViewStyle } from "react-native";
import { DisplayName } from "./DisplayName";
import VerifiedBadge from "./VerifiedBadge";

type UserLike =
  | {
      displayName?: string | null;
      username?: string | null;
      isVerified?: boolean;
    }
  | null
  | undefined;

type Props = Omit<React.ComponentProps<typeof DisplayName>, "user"> & {
  user: UserLike;
  containerStyle?: StyleProp<ViewStyle>;
  badgeSize?: number;
};

export function VerifiedDisplayName({
  user,
  containerStyle,
  badgeSize = 20,
  ...displayNameProps
}: Props) {
  return (
    <View
      style={[
        { flexDirection: "row", alignItems: "center", gap: 6 },
        containerStyle,
      ]}
    >
      <DisplayName user={user} {...displayNameProps} />
      {user?.isVerified ? <VerifiedBadge size={badgeSize} /> : null}
    </View>
  );
}
